import React, { useState, useEffect } from "react";
// import DatePicker from "../DatePicker";
import DatePicker from "../DatePicker/reactDate";
import { Form, Button, Row, Col } from "react-bootstrap";
import {
  getTimeSlotsWithoutLocationId,
  getSuggestedTimeSlots,
  getAppointmentAvailableDates
} from "services/api-service";
import "../../style.scss";

import { vipStyle } from "utils/common";

import moment from "moment";
import {
  DAY_MONTH_YEAR,
  YEAR_MONTH_DAY_2,
  addBusinessDays
} from "constants/date";

import { useDispatch, useSelector, batch } from "react-redux";

import {
  changeSelectedDate,
  changeSelectedTimeSlot,
  changeAttendingWithAnother,
  changeAnotherNric,
  changeAnotherSelectedTimeSlot
} from "redux/appointmentBooking";

import { ValidateNRICData, INDEX } from "constants/appointment";
import _ from "lodash";

import { EARLIEST_APPOINTMENT_AVAILABLE, SELECT_DATE } from "constants/text";
import {
  Radio,
  RadioList,
  Disclaimer,
  HomeButton,
  NextButton,
  CommonButton
} from "../CommonUI";

const { NRIC_INDEX } = INDEX;

const YES = "1";
const NO = "0";
const ZERO = 0;
const MINUTES = "minutes";

export default function CallAppointmentBooking({
  onOpenModal,
  onSubmit,
  onNavigate
}) {
  const dispatch = useDispatch();

  const {
    attendingWithAnother,
    selectedApptType,
    selectedDate,
    selectedTimeSlot,
    registeredAppointmentId,
    anotherNric,
    defaultLocationId
  } = useSelector((state) => state.appointmentBooking);
  const { nric } = useSelector((state) => state.appointment);
  const { isLoading } = useSelector((state) => state.loading);

  const [acceptTermAndCondition, setAcceptTermAndCondition] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  // const [suggestedSlotDay, setSuggestedSlotDay] = useState(99);
  const [availableDates, setAvailableDates] = useState([]);
  const [validateErrors, setValidateErrors] = useState([]);
  const [validated, setValidated] = useState(false);

  // const tomorrowDate = addBusinessDays(new Date(), 1);
  // const tomorrowDate = moment().add(1, "day").format(YEAR_MONTH_DAY_2);

  const handleSelectedTimeSlots = (id, scheduleDate) => {
    if (attendingWithAnother !== YES) {
      dispatch(changeSelectedTimeSlot({ value: id, label: scheduleDate }));
      return;
    }
    if (getNextTimeSlot(id)) {
      batch(() => {
        dispatch(changeSelectedTimeSlot({ value: id, label: scheduleDate }));
        dispatch(changeAnotherSelectedTimeSlot(getNextTimeSlot(id)));
      });
    }
  };

  const onChangeDate = (date) => dispatch(changeSelectedDate(date));

  useEffect(() => {
    console.log("v18");
    // dispatch(changeSelectedDate(tomorrowDate));
     getInitialData();
  }, []);

  const getInitialData = async () => {
    // const response = await getSuggestedTimeSlots(selectedApptType.value);

    // if (response.data)
    //   setSuggestedSlotDay(response.data.data[0]?.suggest_avaialbe_slot_day);

    const { data: availableDates } = await getAppointmentAvailableDates(
      selectedApptType.value,
      defaultLocationId
    );

    if (!availableDates) return;

    setAvailableDates(
      availableDates.data.map((date) => new Date(date.apptDate))
    );
    dispatch(
      changeSelectedDate(
        moment(availableDates.data[0].apptDate).format(YEAR_MONTH_DAY_2)
      )
    );
  };

  useEffect(() => getTimeSlotsData(), [selectedDate]);

  const getTimeSlotsData = async () => {
    let response = null;
    try {
      dispatch(changeSelectedTimeSlot({ value: "", label: "" }));
      setTimeSlots([]);

      response = await getTimeSlotsWithoutLocationId(
        moment(selectedDate).format(YEAR_MONTH_DAY_2),
        selectedApptType.value
      );

      setTimeSlots(response.data.data);
    }catch(e){
      console.log("***", e)
      // setTimeSlots([]);
    }
  };

  const onConfirm = () => onOpenModal && onOpenModal();

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (attendingWithAnother === YES) {
      const validateErrors = ValidateNRICData(anotherNric, nric);
      setValidateErrors(validateErrors);

      (!e.currentTarget.checkValidity() || validateErrors.length === ZERO) &&
        e.stopPropagation();

      setValidated(true);
      if (validateErrors.length !== ZERO) {
        window.scrollTo(0, 0);
        return;
      }
    }

    onSubmit && onSubmit();
  };

  const goToSummary = () => onNavigate && onNavigate();

  const onChangeRadio = (e) => {
    batch(() => {
      dispatch(changeSelectedTimeSlot({ value: "", label: "" }));
      dispatch(changeAnotherSelectedTimeSlot({ value: "", label: "" }));
      dispatch(changeAnotherNric(""));
      dispatch(changeAttendingWithAnother(e.target.value));
    });
  };

  const onChangeNric = (e) => dispatch(changeAnotherNric(e.target.value));

  const getNextTimeSlot = (timeSlotId) => {
    const index = timeSlots.findIndex((x) => x.id === timeSlotId);
    const nextTimeSlot = timeSlots[index + 1];

    if (_.isEmpty(nextTimeSlot)) {
      return null;
    }

    const curTimeSlot = timeSlots[index];
    if (
      moment(nextTimeSlot.date_time).isSame(
        moment(curTimeSlot.date_time).add(
          curTimeSlot.TIMESLOT_INTERVAL,
          MINUTES
        )
      )
    ) {
      return { value: nextTimeSlot.id, label: nextTimeSlot.schedule_dt };
    }

    return null;
  };

  const disabled =
    !isLoading && selectedTimeSlot.value && acceptTermAndCondition
      ? false
      : true;

  return (
    <div className="row">
      <Form noValidate validated={validated} onSubmit={handleOnSubmit}>
        <div className="offset-xl-1 col-xl-10">
          <div
            className="p-3"
            ref={(n) => vipStyle(n, { "padding-top": 0, "margin-bottom": 0 })}
          >
            {/* <DatePicker
              className="mb-5 max-with-250"
              label={SELECT_DATE}
              value={selectedDate}
              onChange={onChangeDate}
              includeDates={availableDates}
            /> */}

            <div>
              These are the earliest time slots available for you.
              <br />
              Please choose your preferred time.
            </div>

            <div className={"mt-2"}>
              <Row style={{ padding: 12 }}>
                <Col lg={4} md={4} className="p-0 my-1">
                  <DatePicker
                    // className="mb-5 max-with-250"
                    label={SELECT_DATE}
                    value={selectedDate}
                    onChange={onChangeDate}
                    includeDates={availableDates}
                  />
                </Col>
              </Row>
            </div>

            {/* {suggestedSlotDay === 3 && (
              <Row className="mb-0">
                <Col xs={11}>{EARLIEST_APPOINTMENT_AVAILABLE}</Col>
              </Row>
            )} */}
            {/* <Row className="mb-0 mt-3">
              <Col xs={5} md={3} lg={2} className="mb-2">
                <div className="border center p-1 bg-light-gray">
                  {moment(selectedDate).format(DAY_MONTH_YEAR)}
                </div>
              </Col>
            </Row> */}

            <Row style={{ padding: 12, paddingBottom: 0 }}>Time</Row>
            <Row className="mb-0">
              {timeSlots?.length > 0 ? (
                timeSlots.map(({ id, schedule_dt: scheduleDate }) => (
                  <Col
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    xl={3}
                    className="mt-2"
                    key={id}
                  >
                    <RadioList>
                      <Radio
                        id="serviceTime"
                        label={scheduleDate}
                        // label={moment(scheduleDate, "H:mmA").format("H:mm A")}
                        onChange={() =>
                          handleSelectedTimeSlots(id, scheduleDate)
                        }
                        checked={id === selectedTimeSlot.value}
                      />
                    </RadioList>
                  </Col>
                ))
              ) : (
                <Col>
                  There is no available time slots for the date. <br />
                  Please choose another date.
                </Col>
              )}
            </Row>

            {selectedApptType.code === "CA" && (
              <div className="mb-0 mt-2">
                <div class="instructions instructions-mod">
                  <div class="instructions-content ">
                    Note: Holder of NRIC number provided in the call appointment
                    booking will be put through SingPass 2FA authentication before
                    connecting to our Customer Service Executive. Please ensure
                    that CPF member is present in the event clarification is
                    needed.
                  </div>
                </div>
              </div>
            )}
            <div className="mt-4">
              <Disclaimer
                onChange={() =>
                  setAcceptTermAndCondition(!acceptTermAndCondition)
                }
                checked={acceptTermAndCondition}
              />
            </div>
          </div>
        </div>
        {/* <div className="form-footer flex-lg-row flex-column justify-content-between"> */}
        <div className="form-footer flex-sm-column flex-sm-column-reverse flex-md-row flex-column-reverse justify-content-sm-between justify-content-start align-items-sm-center align-items-end">
          <div className="mt-2 mobile-w-100 mobile-m-lr-0">
            <HomeButton onClick={onConfirm} />
          </div>
          {/* <div className="d-flex flex-sm-row flex-column"> */}
          <div className="d-flex flex-md-row flex-column-reverse mobile-w-100 ">
            {registeredAppointmentId && (
              <div style={{ marginRight: window.innerWidth <= 990 ? 0 : 10 }}>
                <div
                  className={`mt-2 mobile-m-lr-0 ${
                    registeredAppointmentId ? "mx-0" : "mx-sm-3 mx-md-3 mx-lg-3"
                  }`}
                >
                  <CommonButton
                    onClick={goToSummary}
                    leftOrRight={"right"}
                    text={"Back to summary"}
                  />
                </div>
              </div>

              // <Button
              //   className="btn cmp-button pbs-style--primary rounded-pill mt-2 mx-2 mx-sm-3 mx-md-3 mx-lg-3"
              //   onClick={goToSummary}
              // >
              //   Back To Summary
              // </Button>
            )}
            <div
              className={`mobile-m-lr-0 mt-2 ${
                registeredAppointmentId ? "mx-0" : "mx-sm-0 mx-md-3 mx-lg-3"
              } `}
            >
              <NextButton text="CONFIRM" type="submit" disabled={disabled} />
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}
